import CalendarModal from '@/components/modals/calendar-modal/CalendarModal';
import {
  FormControl,
  FormField,
  FormItem,
  FormLabel,
  FormMessage
} from '@/components/ui/form';
import { Input } from '@/components/ui/input';
import useMixPanel from '@/hooks/useMixPanel';
import { useRootStore } from '@/providers/root-store-provider';
import { StepService } from '@/stores/slices/step-service/step-services.types';
import {
  maxHeightInputValidation,
  maxWeightInputValidation
} from '@/utils/utils';
import React from 'react';
import { UseFormReturn } from 'react-hook-form';
import { useTranslation } from 'react-i18next';

const ParticipantForm: React.FC<{
  form: UseFormReturn<any, any, undefined>;
  userIsParticipant: boolean;
  index: number;
}> = ({ form, userIsParticipant, index }) => {
  const stepServicesData: StepService | null = useRootStore(
    (store) => store.stepServicesData
  );
  const { t } = useTranslation(['newBooking', 'common']);
  const Mixpanel = useMixPanel();
  return (
    <div className="border border-primary p-6 rounded-md flex flex-col gap-8">
      <h3 className="text-sm font-normal text-primary">
        {t('stepParticipants.participant') + ' '}
        {userIsParticipant ? index + 2 : index + 1} -
        {' ' + stepServicesData?.service?.name}
      </h3>
      <FormField
        control={form.control}
        name={`participants.${index}.firstName`}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('stepParticipants.form.firstName')}</FormLabel>
            <FormControl>
              <Input
                onClick={() =>
                  Mixpanel.track(
                    `press participants array[${index}]  first name input`,
                    {
                      screen: 'New Booking'
                    }
                  )
                }
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name={`participants.${index}.lastName`}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('stepParticipants.form.lastName')}</FormLabel>
            <FormControl>
              <Input
                onClick={() =>
                  Mixpanel.track(
                    `press participants array[${index}]  last name input`,
                    {
                      screen: 'New Booking'
                    }
                  )
                }
                {...field}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name={`participants.${index}.birthdate`}
        render={({ field }) => (
          <FormItem className="flex flex-col ">
            <FormLabel>{t('stepParticipants.form.birth')}</FormLabel>
            <CalendarModal
              value={field.value}
              onClickInputLabel={() =>
                Mixpanel.track(
                  `press participants array[${index}] birthday day button`,
                  {
                    screen: 'New Booking'
                  }
                )
              }
              onAccept={(value) => {
                field.onChange(value);
                Mixpanel.track(
                  `select date from  participants array[${index}] birthday calendar `,
                  {
                    screen: 'New Booking'
                  }
                );
              }}
              initialFocus
              dropDownPicker
            />
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name={`participants.${index}.weight`}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('stepParticipants.form.weight')}</FormLabel>
            <FormControl>
              <Input
                onClick={() =>
                  Mixpanel.track(
                    `press participants array[${index}] weight input`,
                    {
                      screen: 'New Booking'
                    }
                  )
                }
                type="number"
                {...field}
                onChange={(e) => {
                  if (maxWeightInputValidation(Number(e.target.value))) {
                    field.onChange(e);
                  }
                }}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
      <FormField
        control={form.control}
        name={`participants.${index}.height`}
        render={({ field }) => (
          <FormItem>
            <FormLabel>{t('stepParticipants.form.height')}</FormLabel>
            <FormControl>
              <Input
                onClick={() =>
                  Mixpanel.track(
                    `press participants array[${index}] height input`,
                    {
                      screen: 'New Booking'
                    }
                  )
                }
                step="1"
                type="number"
                {...field}
                onChange={(e) => {
                  if (maxHeightInputValidation(Number(e.target.value))) {
                    field.onChange(e);
                  }
                }}
              />
            </FormControl>
            <FormMessage />
          </FormItem>
        )}
      />
    </div>
  );
};

export default ParticipantForm;
